import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			cardProps: {
				props: {
					title: 'Fund Managers',
				},
				queries: {},
			},
			carouselProps: {
				hideDots: true,
				infiniteScroll: true,
				navigationHidesWhenSingle: true,
			},
			defaultPhoto: 'FundManagerPlaceholder.svg',
			fundManagers: {
				entityType: 'CLSS',
				queryOptionsType: 'fundManagers',
				sort: {
					direction: 'ASC',
					key: 'name',
					type: 'string',
				},
			},
			redirects: [
				{
					id: 'bio',
					redirect: {
						defaultUrl: '',
					},
				},
			],
		},
		bio: {
			props: {
				collapse: {
					maxLength: 100,
					suffix: '...',
				},
				hasHtmlContent: true,
				toggleButtons: {
					collapse: {
						text: '...Read less',
					},
					expand: {
						text: 'Read More',
					},
				},
				toggleState: 'collapsed',
				value: '',
			},
			queries: {
				value: {
					key: 'biography',
					queryOptionsType: 'fundManager',
				},
			},
		},
		definitionList: {
			queries: {
				items: [
					{
						definition: {
							extendedKey: 'joined_firm_in',
							key: 'extended',
							queryOptionsType: 'fundManager',
						},
						term: {
							queryOptionsType: 'none',
							value: 'Joined in',
						},
					},
				],
				termSuffix: {
					queryOptionsType: 'none',
					value: ': ',
				},
			},
		},
		fundManagerCard: {
			gridProps: {
				grid: {
					rows: [
						{
							columns: [
								{
									components: [
										{
											key: 'components.image',
											name: 'image',
										},
										{
											key: 'components.assetImage',
											name: 'assetImage',
										},
										{
											key: 'components.title',
											name: 'title',
										},
										{
											key: 'components.name',
											name: 'name',
										},
										{
											key: 'components.definitionList',
											name: 'definitionList',
										},
										{
											key: 'components.overlay',
											name: 'overlay',
										},
									],
								},
							],
						},
					],
				},
			},
		},
		image: {
			queries: {
				value: {
					extendedKey: '',
					key: 'code',
					queryOptionsType: 'fundManager',
				},
			},
		},
		assetImage: {
			queries: {
				src: {
					queryOptionsType: 'asset',
					key: 'citywire_AAA_small.png',
					assetOptions: {
						source: 'ksysAsset',
					},
				},
			},
		},
		name: {
			queries: {
				value: {
					extendedKey: '',
					key: 'name',
					queryOptionsType: 'fundManager',
				},
			},
		},
		overlay: {
			cardProps: {
				title: 'Biography',
			},
			closeButtonProps: {
				text: 'X',
			},
			gridProps: {
				grid: {
					rows: [
						{
							columns: [
								{
									components: [
										{
											key: 'components.name',
											name: 'name',
										},
									],
								},
							],
						},
						{
							columns: [
								{
									components: [
										{
											key: 'components.assetImage',
											name: 'assetImage',
										},
									],
								},
							],
						},
						{
							columns: [
								{
									components: [
										{
											key: 'components.definitionList',
											name: 'definitionList',
										},
									],
								},
							],
						},
						{
							columns: [
								{
									components: [
										{
											key: 'components.bio',
											name: 'bio',
										},
									],
								},
							],
						},
					],
				},
			},
			openButtonProps: {
				text: 'Read Full Bio',
			},
			props: {
				value: '',
			},
			queries: {
				value: {
					key: 'biography',
					queryOptionsType: 'fundManager',
				},
			},
		},
		title: {
			queries: {
				value: {
					extendedKey: 'reporting_title_1',
					key: 'extended',
					queryOptionsType: 'fundManager',
				},
			},
		},
	},
	data: {
		context: {
			entityByType: {
				CLSS: {
					clientCodeProperty: 'isin',
					include: {
						fundManagers: {},
					},
					inputKey: 'isin',
				},
			},
		},
	},
	token: '49907d96-9d9e-4576-8cfd-b9af0a2d7ad7',
};
